var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('Spinner'):_c('div',{staticClass:"min-h-screen flex flex-col justify-between"},[_c('div',{staticClass:"mx-auto w-full max-w-3xl py-20 bg-white"},[(_vm.error)?_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.error))]):_c('Markdown',{attrs:{"source":_vm.markdown}})],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }